import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=2fd66a91&scoped=true&"
import script from "./CatalogList.vue?vue&type=script&lang=js&"
export * from "./CatalogList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=2fd66a91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd66a91",
  null
  
)

export default component.exports